import { Select } from 'component/Select'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'

export const PaginationTop = observer(() => {
  const demo = useDemo()
  const { count, limit, limits } = demo.form
  const options = limits.map((n) => ({ value: n.toFixed() }))

  const onLimit = useLatestCallback((value: string) => {
    demo.form.limit = parseInt(value)
  })

  if (demo.stand) return null

  return (
    <Space gap={16} minHeight={32} opposite wrap>
      <Space gap={8}>
        <Typo size={11} medium upper secondary>
          {i18n('ItemsCount')}
        </Typo>
        <Typo size={11} medium>
          {count}
        </Typo>
      </Space>
      {count > limits[0] && (
        <Space gap={4}>
          <Typo size={11} medium upper secondary>
            {i18n('ShowOnPage')}
          </Typo>
          <Select
            value={limit.toFixed()}
            options={options}
            onChange={onLimit}
          />
        </Space>
      )}
    </Space>
  )
})
